<!-- components/DeleteStorageModal.vue -->
<template>
  <BaseModal :title="'Delete Storage'" @close="closeModal">
    <template #modalContent>
      <div class="modal-content-wrapper">
        <div>
          <h3 class="modal-heading text-xl font-bold text-white p-2">Confirm Deletion</h3>
          <div class="flex flex-col mt-8">
            <p class="collect-em-label">
              //Do you really want to delete the storage "{{ storage.name }}"?
            </p>
            <span>deleteStorage()</span>
          </div>
          <vs-button class="mt-8" type="border" :disabled="isDeleting" @click="confirmDelete">
            {{ isDeleting ? 'Deleting...' : '>>delete' }}
          </vs-button>
        </div>
        <div class="cast-modal-bottom">
          <p>
            >> Delete Storage > <span>All the data related with this storage will be erased</span>
          </p>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/common/BaseModal.vue";
import api from '@/http/api/api.js'
import constants from "../../../../../constant";

export default {
  name: 'DeleteStorageModal',
  props: {
    storage: {
      type: Object,
      required: true,
      validator: (storage) => 'id' in storage && 'name' in storage,
    },
    closeModal: {
      type: Function,
      required: true,
    },
    fetchStorages: {
      type: Function,
      required: true,
    }
  },
  components: {
    BaseModal,
  },
  data() {
    return {
      isDeleting: false,
    };
  },
  methods: {
    async confirmDelete() {
      this.isDeleting = true;
      try {
        await api.delete(`${constants.apiCastUrl}/api/v1/storageproxy/storages/${this.storage.id}`);
        await this.fetchStorages();
        this.$vs.notify({
          title: 'Success',
          text: `Storage "${this.storage.name}" deleted successfully!`,
          color: 'success',
        });
      } catch (error) {
        console.error('Error deleting storage:', error);
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to delete storage. Please try again.',
          color: 'danger',
        });
      }
    },
  },
};
</script>

<style scoped>
.heading {
  border-top: 1px dotted white;
  border-bottom: 1px dotted white;
}

.collect-em-label {
  color: #5b96eb !important;
}
</style>